import { useTranslation } from 'react-i18next';

import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useCasinoFavoriteGameIds } from './use-casino-favorites';
import { getCasinoGamesByIds } from './use-casino-game-history';
import { isCasinoGameAvailableOnPlatform } from './use-casino-games';

/*
    Builds a layout object for favorited games based on the user's favorites list.
*/
export const useFavoriteGames = () => {
    const { t } = useTranslation('casino');
    const { data: favoriteGameIds = [], isPending: isFavoriteGameIdsPending } = useCasinoFavoriteGameIds();

    return useQuery({
        queryKey: ['favorite-games', favoriteGameIds],
        queryFn: async () => {
            if (!favoriteGameIds || favoriteGameIds.length === 0) {
                return null;
            }

            const gamesData = await getCasinoGamesByIds(favoriteGameIds);

            const orderedGames = favoriteGameIds
                .map(id => gamesData.items.find(game => game.id === id))
                .filter((game): game is (typeof gamesData.items)[0] => game !== undefined)
                .filter(isCasinoGameAvailableOnPlatform);

            return {
                id: 'favorites',
                name: t('favorites'),
                flags: ['single-row'],
                items: orderedGames,
            };
        },
        placeholderData: keepPreviousData,
        enabled: !isFavoriteGameIdsPending,
    });
};
